import clsx from "clsx";

export const FormControl: React.FC<
  {
    children: React.ReactElement;
    error?: string;
    hint?: string;
  } & (
    | {
        id?: string;
        label?: never;
      }
    | {
        id: string;
        label: React.ReactNode;
      }
  )
> = ({ id, label, children, error, hint }) => {
  const message = error ?? hint;
  return (
    <div className="group/form-control form-control" aria-invalid={!!error}>
      {label && (
        <label className="label" htmlFor={id}>
          <span className="label-text after:text-error group-has-[:required]/form-control:after:content-['*']">
            {label}
          </span>
        </label>
      )}
      {children}
      {message && (
        <div className={clsx("label label-text", error && "text-error")}>
          {message}
        </div>
      )}
    </div>
  );
};
